import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const SITE_ORIGIN = "https://www.diskola.id";

const HOME_DESCRIPTION =
  "Kami menghadirkan layanan dan integrasi terbaik PPDB, PSB, daftar ulang, pembelajaran online, rekap absensi, sistem manajemen, dan transaksi non-tunai di sekolah.";

/** Selaras dengan hero di ProdukView.vue */
const PRODUK_DESCRIPTION =
  "Solusi terintegrasi untuk administrasi, pembelajaran, dan layanan sekolah — dirancang agar mudah dipakai oleh sekolah, guru, siswa, dan orang tua.";

const KEBIJAKAN_DESCRIPTION =
  "Kebijakan privasi diskola.id: bagaimana kami mengumpulkan, menggunakan, dan melindungi data Anda saat menggunakan layanan kami.";

function upsertMeta(attr, key, content) {
  const selector = `meta[${attr}="${key}"]`;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function applyDocumentMeta(to) {
  const title = to.meta.title || "diskola.id";
  const description = to.meta.description || HOME_DESCRIPTION;
  const path = to.path || "/";
  const ogUrl = path === "/" ? `${SITE_ORIGIN}/` : `${SITE_ORIGIN}${path}`;

  document.title = title;

  upsertMeta("name", "description", description);
  upsertMeta("property", "og:title", title);
  upsertMeta("property", "og:description", description);
  upsertMeta("property", "og:url", ogUrl);
  upsertMeta("property", "og:type", to.meta.ogType || "website");
  upsertMeta("name", "twitter:title", title);
  upsertMeta("name", "twitter:description", description);
}

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      title: "diskola.id",
      description: HOME_DESCRIPTION,
      ogType: "website",
    },
  },
  {
    path: "/produk",
    name: "produk",
    component: () => import(/* webpackChunkName: "about" */ "../views/ProdukView.vue"),
    meta: {
      title: "Produk | diskola.id",
      description: PRODUK_DESCRIPTION,
      ogType: "website",
    },
  },
  {
    path: "/kebijakan-privasi",
    name: "kebijakanPrivasi",
    component: () => import(/* webpackChunkName: "about" */ "../views/KebijakanPrivasi.vue"),
    meta: {
      title: "Kebijakan Privasi | diskola.id",
      description: KEBIJAKAN_DESCRIPTION,
      ogType: "article",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.afterEach((to) => {
  applyDocumentMeta(to);
});

export default router;
